import { render, staticRenderFns } from "./bank_statement_relations.vue?vue&type=template&id=36b29e8f&scoped=true"
import script from "./bank_statement_relations.vue?vue&type=script&lang=js"
export * from "./bank_statement_relations.vue?vue&type=script&lang=js"
import style0 from "./bank_statement_relations.vue?vue&type=style&index=0&id=36b29e8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b29e8f",
  null
  
)

export default component.exports